import React, { useEffect } from 'react';
import './SoftwareDesign.css';

const SoftwareDesign = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Event Listener Design",
            description: "Implementing listeners to capture and process real-time events from IoT devices for seamless data flow."
        },
        {
            title: "API Development Design",
            description: "Creating REST or GraphQL APIs to enable efficient data transfer from databases to frontends."
        },
        {
            title: "Security Layer Design",
            description: "Implementing encryption and authentication to secure data flow across IoT software systems."
        },
        {
            title: "Cloud Solutions Design",
            description: "Architecting cloud-based solutions to enhance scalability and data management for IoT applications."
        },
        {
            title: "Cloud Platforms and Maturity Analysis Design",
            description: "Leveraging Google Cloud, AWS, and maturity analysis to optimize IoT cloud deployments."
        },
        {
            title: "Windows Application and Cloud Hosting Design",
            description: "Designing and hosting Windows applications on cloud platforms for robust IoT integration."
        },
        {
            title: "Dashboard and Reporting Design",
            description: "Developing intuitive dashboards and reporting tools for real-time IoT data visualization."
        },
        {
            title: "Mobile Apps Design",
            description: "Creating responsive mobile apps for IoT control and monitoring on iOS and Android."
        },
        {
            title: "Software Testing Design",
            description: "Implementing rigorous testing to ensure reliable integration of cloud, mobile, and IoT software."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Software Design and Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our software design services deliver robust, scalable, and secure solutions tailored for IoT and embedded systems, ensuring seamless integration and optimal performance.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SoftwareDesign;